import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useCodeTables = ({
  page = 1,
  rows = 10,
  searchTerm,
  enabled = true,
  refetchOnWindowFocus = true
} = {}) => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["codeTables", tenantVal, page, rows, searchTerm],
    queryFn: async () => {
      if (!tenantVal) return null;
      const axiosInstance = await createAxiosInstance();
      
      const params = new URLSearchParams({
        page: page.toString(),
        rows: rows.toString()
      });

      if (searchTerm) params.append('searchTerm', searchTerm);

      const response = await axiosInstance.get(
        `${tenantVal}/codetable/get?${params.toString()}`
      );
      return response.data;
    },
    enabled: enabled && !!tenantVal,
    refetchOnWindowFocus,
    meta: { errorMessage: "Error fetching code tables data" },
  });
};